function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9432"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9432"] = parcelRequire;
}
parcelRequire.register("4SSe9", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $38e644f71e40bb30$export$6503ec6e8aabbaf; }, function (v) { return $38e644f71e40bb30$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $38e644f71e40bb30$export$f7ad0328861e2f03; }, function (v) { return $38e644f71e40bb30$export$f7ad0328861e2f03 = v; });
var $38e644f71e40bb30$export$6503ec6e8aabbaf;
var $38e644f71e40bb30$export$f7ad0328861e2f03;
"use strict";
var $38e644f71e40bb30$var$mapping = {};
function $38e644f71e40bb30$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$38e644f71e40bb30$var$mapping[keys[i]] = pairs[keys[i]];
}
function $38e644f71e40bb30$var$resolve(id) {
    var resolved = $38e644f71e40bb30$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$38e644f71e40bb30$export$6503ec6e8aabbaf = $38e644f71e40bb30$var$register;
$38e644f71e40bb30$export$f7ad0328861e2f03 = $38e644f71e40bb30$var$resolve;

});

var $7c860c7dfac5d4a1$exports = {};

(parcelRequire("4SSe9")).register(JSON.parse('{"3z9Oy":"index.7886e6ac.js","8OaUg":"amazon-icon1x.985b1de5.png","4MGAN":"amazon-icon2x.b774c146.png","gBscj":"applebook-icon1x.a9f158e0.png","7OUVG":"applebook-icon2x.7ba433f7.png","2qXmr":"bookshop-icon1x.95f5821d.png","iTw7C":"bookshop-icon2x.2b4b4a60.png","ko6Yt":"index.a76207dc.js","5GORe":"index.7611b512.js"}'));

parcelRequire("j2GOd");
parcelRequire("lyquk");
parcelRequire("clbZJ");

var $j2GOd = parcelRequire("j2GOd");

var $j2GOd = parcelRequire("j2GOd");
// const BASE_URL_MY =
//   'https://books-backend.p.goit.global/books/category?category=';
// const ENDPOINT = 'Series%20Books';
// const API_KEY = '';
// let page = 1;
// const list = document.querySelector('.js-list-rendering');
// const loadMore = document.querySelector('.js-load_more-rendering');
const $889611e2e1d4180e$var$bookCollection = document.querySelector(".books-gallery");
const $889611e2e1d4180e$var$api = new (0, $j2GOd.APIService)();
async function $889611e2e1d4180e$export$2e2bcd8739ae039(category) {
    const res = await $889611e2e1d4180e$var$api.fetchBooksByCategory(category);
    const books = await res.data;
    function removeLastWord(category) {
        let words = category.split(" ");
        words.pop();
        let result = words.join(" ");
        return result;
    }
    function LastWord(category) {
        var words = category.trim().split(" "); //Splitting sentence into words
        return words[words.length - 1]; //Returning the last word
    }
    function collectionMarkup() {
        return `<h1 class="collection-title">${removeLastWord(category)} <span>${LastWord(category)}</span></h1>
    <ul class="top-books rendering-gap js-list-rendering">

    ${books.map(({ title: title , book_image: book_image , author: author , _id: _id  })=>{
            return `<li class="book-card" data-id="${_id}">
        <div class="book-thumb">
      <img class="book-cover" src="${book_image}" alt="${title}">
      <div class="quick-view">
                <p class="quick-view-text">QUICK VIEW</p>
                </div>
                </div>
                <div class="book-descr">
      <h2 class="book-name">${title}</h2>
      <h3 class="book-author">${author}</h3>
      </div>
  </li>`;
        }).join("")}
    </ul>
    
    `;
    }
    $889611e2e1d4180e$var$bookCollection.innerHTML = collectionMarkup();
} // const collectionMarkup = books
 //     .map(({ title, book_image, author, _id }) => {
 //       return `<li class="book-card " id="${_id}">
 //       <img class="book-cover" src="${book_image}" alt="${title}">
 //       <h2 class="book-name">${title}</h2>
 //       <h3 class="book-author">${author}</h3>
 //   </li>`;
 //     })
 //     .join('');
 //   bookCollection.innerHTML = collectionMarkup;
 // loadMore.addEventListener('click', handlerPagination);
 // servisBook()
 //   .then(data => {
 //     list.insertAdjacentHTML('beforeend', createMarkup(data));
 //   })
 //   .catch(err => console.log(err));
 // function createMarkup(arr) {
 //   return arr
 //     .map(
 //       ({
 //         title,
 //         book_image,
 //         author,
 //         _id,
 //       }) => `<li class="flex-element" id="${_id}">
 //       <img src="${book_image}" alt="${title}">
 //       <h2>${title}</h2>
 //       <p>${author}</p>
 //   </li>`
 //     )
 //     .join('');
 // }



var $j2GOd = parcelRequire("j2GOd");


var $ipb79 = parcelRequire("ipb79");

var $bZsAe = parcelRequire("bZsAe");
const $de64f6c260b75bf3$var$api = new (0, $j2GOd.APIService)();
const $de64f6c260b75bf3$var$bookGallery = document.querySelector(".books-gallery");
async function $de64f6c260b75bf3$var$getBestSellers() {
    try {
        (0, $bZsAe.Loading).standard("Loading...");
        const response = await $de64f6c260b75bf3$var$api.fetchBestSellersBooks();
        (0, $bZsAe.Loading).remove("Loading...");
        const bestSellers = await response.data;
        return bestSellers;
    } catch (error) {
        console.log(error);
        (0, $bZsAe.Loading).remove("Loading...");
        (0, $ipb79.reportsFailure)("Sorry, no books were found. Please try again.");
    }
}
function $de64f6c260b75bf3$var$createBookCategoryMarkup(category) {
    return `
  
    <li class="book-category-item">
      <p class="book-category">${category.list_name}</p>
      <ul class="top-books bestsel-books js-list-rendering">
        ${category.books.map((book)=>{
        return `
              <li class="book-card flex-element" data-id="${book._id}">
              <div class="book-thumb">
                <img class="book-cover" src="${book.book_image}" alt="${book.title}"/>
                <div class="quick-view">
                <p class="quick-view-text">QUICK VIEW</p>
                </div>
                </div>
                <div class="book-descr">
                <h2 class="book-name">${book.title}</h2>
                <h3 class="book-author">${book.author}</h3>
                </div>
              </li>
            `;
    }).join("")}
      </ul>
      <button class="book-card-btn" type="button" data-category="${category.list_name}">see more</button>
    </li>
  `;
}
async function $de64f6c260b75bf3$export$2e2bcd8739ae039() {
    let bookCategories = '<ul class="top-books rendering-gap js-list-rendering">';
    try {
        const topBooks = await $de64f6c260b75bf3$var$getBestSellers();
        for (let category of topBooks)bookCategories += $de64f6c260b75bf3$var$createBookCategoryMarkup(category);
        bookCategories += "</ul>";
        $de64f6c260b75bf3$var$bookGallery.innerHTML = `<h1 class="collection-title">Best Sellers <span>Books</span></h1>`;
        const bookCollection = document.createElement("div");
        bookCollection.className = "books-collection";
        bookCollection.innerHTML = bookCategories;
        bookCollection.addEventListener("click", $de64f6c260b75bf3$var$onSeeMoreBtnClick);
        $de64f6c260b75bf3$var$bookGallery.appendChild(bookCollection);
    } catch (error) {
        console.log(error);
    }
}
if ($de64f6c260b75bf3$var$bookGallery) try {
    $de64f6c260b75bf3$export$2e2bcd8739ae039();
} catch (error) {
    console.log(error);
}
async function $de64f6c260b75bf3$var$onSeeMoreBtnClick(e) {
    if (e.target.nodeName !== "BUTTON") return;
    const target = e.target;
    try {
        if (target.matches("button[data-category]")) {
            const category = target.dataset.category;
            const titleCollection = $de64f6c260b75bf3$var$bookGallery.querySelector(".collection-title");
            titleCollection.innerHTML = `${$de64f6c260b75bf3$var$removeLastWord(category)} <span>${$de64f6c260b75bf3$var$LastWord(category)}</span>`;
            (0, $423e4fe9a845d55f$export$71b4ecbda78cfee9)(category);
            await $de64f6c260b75bf3$var$createBooksOnSeeMoreBtn(category);
        }
    } catch (error) {
        console.log(error);
    }
}
function $de64f6c260b75bf3$var$removeLastWord(category) {
    let words = category.split(" ");
    words.pop();
    let result = words.join(" ");
    return result;
}
function $de64f6c260b75bf3$var$LastWord(category) {
    var words = category.trim().split(" "); //Splitting sentence into words
    return words[words.length - 1]; //Returning the last word
}
async function $de64f6c260b75bf3$var$createBooksOnSeeMoreBtn(category) {
    try {
        (0, $bZsAe.Loading).standard("Loading...");
        const res = await $de64f6c260b75bf3$var$api.fetchBooksByCategory(category);
        const books = await res.data;
        (0, $bZsAe.Loading).remove("Loading...");
        function collectionMarkup() {
            return `
    <ul class="top-books rendering-gap js-list-rendering">
    ${books.map(({ title: title , book_image: book_image , author: author , _id: _id  })=>{
                return `
        <li class="book-card" data-id=${_id}>
        <div class="book-thumb">
         <img class="book-cover" src="${book_image}" alt="${title}">
         <div class="quick-view">
          <p class="quick-view-text">QUICK VIEW</p>
         </div>
        </div>
        <div class="book-descr">
      <h2 class="book-name">${title}</h2>
      <h3 class="book-author">${author}</h3>
      </div>
  </li>
  `;
            }).join("")}
    </ul>`;
        }
        const bookCollection = $de64f6c260b75bf3$var$bookGallery.querySelector(".books-collection");
        bookCollection.innerHTML = collectionMarkup();
    } catch (error) {
        console.log(error);
        (0, $bZsAe.Loading).remove("Loading...");
        (0, $ipb79.reportsFailure)("Sorry, no books  were found. Please try again.");
    }
} // ========================//
 // On All Categories Click //
 // ========================//
 //             if (text.length > limit) {
 //               cuttedText += '...';
 //             }



var $ipb79 = parcelRequire("ipb79");

var $bZsAe = parcelRequire("bZsAe");
const $423e4fe9a845d55f$var$api = new (0, $j2GOd.APIService)();
const $423e4fe9a845d55f$var$categoriesList = document.querySelector(".book-category__list");
// const bookCollection = document.querySelector('.books-gallery');
async function $423e4fe9a845d55f$var$getBooksCategoryList() {
    try {
        (0, $bZsAe.Loading).standard("Loading...");
        //  if (!response.ok) {
        //   throw new Error();
        //    return
        // }
        const resp = await $423e4fe9a845d55f$var$api.fetchBooksCategoryList();
        (0, $bZsAe.Loading).remove("Loading...");
        const data = await resp.data;
        return data;
    } catch (error) {
        console.log(error);
        (0, $ipb79.reportsFailure)("Sorry, no books 555 were found. Please try again.");
    }
}
async function $423e4fe9a845d55f$var$getBookCategory() {
    // try {
    const categories = await $423e4fe9a845d55f$var$getBooksCategoryList();
    const markup = categories.map((cat)=>`<li class="book-category__list-item">${cat.list_name}</li>`).join("");
    $423e4fe9a845d55f$var$categoriesList.insertAdjacentHTML("beforeend", markup);
}
// catch (error) {
//   console.log(error);
//    reportsFailure('Sorry, no books were found. Please try again.')
// }
// }
if ($423e4fe9a845d55f$var$categoriesList) {
    $423e4fe9a845d55f$var$getBookCategory();
    $423e4fe9a845d55f$var$categoriesList.addEventListener("click", $423e4fe9a845d55f$var$onCategoryListSearchCategory);
}
async function $423e4fe9a845d55f$var$onCategoryListSearchCategory(e) {
    if (e.target.nodeName !== "LI") return;
    const category = e.target.textContent;
    $423e4fe9a845d55f$export$71b4ecbda78cfee9(category);
    if (category !== "All categories") await (0, $889611e2e1d4180e$export$2e2bcd8739ae039)(category);
    else await (0, $de64f6c260b75bf3$export$2e2bcd8739ae039)();
}
function $423e4fe9a845d55f$export$71b4ecbda78cfee9(category) {
    const items = document.querySelectorAll(".book-category__list-item");
    for (const item of items)if (item.textContent === category) item.classList.add("active");
    else item.classList.remove("active");
}





var $ipb79 = parcelRequire("ipb79");

var $bZsAe = parcelRequire("bZsAe");
const $7c9b6e419670c53b$export$ad5e81312907638b = {
    btn: document.querySelector(".scrollBtn"),
    show () {
        this.btn.classList.remove("scrollBtn-hide");
    },
    hide () {
        this.btn.classList.add("scrollBtn-hide");
    },
    addEventListener () {
        if (this.btn) {
            window.addEventListener("scroll", ()=>{
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                scrollY > 100 ? this.show() : this.hide();
            });
            this.btn.onclick = ()=>{
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            };
        }
    }
};
$7c9b6e419670c53b$export$ad5e81312907638b.addEventListener();



var $d0qiv = parcelRequire("d0qiv");

var $j2GOd = parcelRequire("j2GOd");
var $970c8eaba6989662$exports = {};

$970c8eaba6989662$exports = new URL((parcelRequire("4SSe9")).resolve("8OaUg"), import.meta.url).toString();


var $6ac5049c15344dc8$exports = {};

$6ac5049c15344dc8$exports = new URL((parcelRequire("4SSe9")).resolve("4MGAN"), import.meta.url).toString();


var $8d03bf859c00cd96$exports = {};

$8d03bf859c00cd96$exports = new URL((parcelRequire("4SSe9")).resolve("gBscj"), import.meta.url).toString();


var $cff94b9787371d15$exports = {};

$cff94b9787371d15$exports = new URL((parcelRequire("4SSe9")).resolve("7OUVG"), import.meta.url).toString();


var $9242bc8258ebce81$exports = {};

$9242bc8258ebce81$exports = new URL((parcelRequire("4SSe9")).resolve("2qXmr"), import.meta.url).toString();


var $4c66a77d1ca3dce7$exports = {};

$4c66a77d1ca3dce7$exports = new URL((parcelRequire("4SSe9")).resolve("iTw7C"), import.meta.url).toString();


const $02917533890b81a6$var$allModal = document.querySelector("#allModal");
const $02917533890b81a6$var$bookList = document.querySelector(".books-gallery");
const $02917533890b81a6$var$addStorageBtn = document.querySelector(".add-storage-button");
const $02917533890b81a6$var$removeStorageBtn = document.querySelector(".remove-storage-btn");
const $02917533890b81a6$var$storageDescription = document.querySelector(".storage-info");
const $02917533890b81a6$var$apiBook = new (0, $j2GOd.APIService)();
const $02917533890b81a6$var$STORAGE_KEY = "storage-data";
let $02917533890b81a6$var$storageArr = [];
let $02917533890b81a6$var$storageObj = {};
if ($02917533890b81a6$var$bookList) {
    $02917533890b81a6$var$addStorageBtn === null || $02917533890b81a6$var$addStorageBtn === void 0 ? void 0 : $02917533890b81a6$var$addStorageBtn.addEventListener("click", $02917533890b81a6$var$onStorageAdd);
    $02917533890b81a6$var$removeStorageBtn === null || $02917533890b81a6$var$removeStorageBtn === void 0 ? void 0 : $02917533890b81a6$var$removeStorageBtn.addEventListener("click", $02917533890b81a6$var$onStorageDelete);
    $02917533890b81a6$var$bookList.addEventListener("click", $02917533890b81a6$var$onIdClick);
}
const $02917533890b81a6$var$idModal = document.querySelector(".about-book-modal");
const $02917533890b81a6$var$idBackdropModal = document.querySelector(".card-backdrop-modal");
function $02917533890b81a6$var$openModalId() {
    if ($02917533890b81a6$var$addStorageBtn.hasAttribute("disabled", "")) (0, $ipb79.reportsWarning)("Please sign up to show a shopping list");
    $02917533890b81a6$var$idModal === null || $02917533890b81a6$var$idModal === void 0 ? void 0 : $02917533890b81a6$var$idModal.classList.remove("is-hidden");
    $02917533890b81a6$var$idBackdropModal === null || $02917533890b81a6$var$idBackdropModal === void 0 ? void 0 : $02917533890b81a6$var$idBackdropModal.classList.remove("is-hidden");
    document.body.style.overflow = "hidden";
    (0, $7c9b6e419670c53b$export$ad5e81312907638b).hide();
}
function $02917533890b81a6$var$onIdClick(e) {
    const bookCard = e.target.closest("li");
    const isBookCard = bookCard && bookCard.hasAttribute("data-id") && bookCard.classList.contains("book-card");
    if (!isBookCard) return;
    const id = bookCard.getAttribute("data-id");
    $02917533890b81a6$var$openModalId();
    $02917533890b81a6$var$createModal(id);
}
async function $02917533890b81a6$var$createModal(bookId) {
    if ($02917533890b81a6$var$allModal) $02917533890b81a6$var$allModal.innerHTML = "";
    try {
        (0, $bZsAe.Loading).standard("Loading...");
        const data = await $02917533890b81a6$var$fetchBookById(bookId);
        $02917533890b81a6$var$storageCheck();
        (0, $bZsAe.Loading).remove("Loading...");
        $02917533890b81a6$var$createMarkup(data);
        return data;
    } catch (error) {
        (0, $bZsAe.Loading).remove("Loading...");
        console.log("Error", error);
        (0, $ipb79.reportsFailure)("Sorry, no books were found. Please try again.");
    }
}
async function $02917533890b81a6$var$fetchBookById(bookId) {
    try {
        $02917533890b81a6$var$storageObj = {};
        const response = await $02917533890b81a6$var$apiBook.fetchBookInfo(bookId);
        const data = response.data;
        $02917533890b81a6$var$storageObj = {
            book_image: data.book_image,
            title: data.title,
            author: data.author,
            marketAmazon: data.buy_links[0].url,
            marketAppleBooks: data.buy_links[1].url,
            marketBookshop: data.buy_links[4].url,
            list_name: data.list_name,
            id: data._id,
            description: data.description
        };
        return data;
    } catch (error) {
        console.log("Error", error);
    }
}
function $02917533890b81a6$var$storageCheck() {
    const storageArr = (0, $d0qiv.isAuthenticated)() ? JSON.parse(localStorage.getItem($02917533890b81a6$var$STORAGE_KEY)) : null;
    const idToFind = $02917533890b81a6$var$storageObj.id;
    if (!storageArr || storageArr.length === 0) {
        $02917533890b81a6$var$addStorageBtn.style.display = "block";
        $02917533890b81a6$var$removeStorageBtn.style.display = "none";
        return;
    } else {
        const objToFind = storageArr.find((obj)=>obj.id === idToFind);
        if (!objToFind) {
            $02917533890b81a6$var$addStorageBtn.style.display = "block";
            $02917533890b81a6$var$removeStorageBtn === null || $02917533890b81a6$var$removeStorageBtn === void 0 ? void 0 : $02917533890b81a6$var$removeStorageBtn.style.display = "none";
        } else {
            $02917533890b81a6$var$addStorageBtn.style.display = "none";
            $02917533890b81a6$var$removeStorageBtn.style.display = "block";
        }
    }
}
function $02917533890b81a6$var$createMarkup(data) {
    const bookModalImage = data.book_image;
    const bookTitle = data.title;
    const bookAuthor = data.author;
    const marketAmazon = data.buy_links[0].url;
    const marketAppleBooks = data.buy_links[1].url;
    const marketBookshop = data.buy_links[4].url;
    const bookDescription = data.description;
    let descriptionMarkup = bookDescription;
    if (bookDescription === "") descriptionMarkup = "Unfortunately, a brief description of this book is currently unavailable. But let that not hinder you from opening its pages and immersing yourself in the unforgettable world it creates.";
    const html = `  
  <img src="${bookModalImage}" alt="Book Image" class="image-about-book-modal">
  <div class="info-modal">
  <h2 class="title-about-book-modal">${bookTitle}</h2>
  <p class="author-about-book-modal"> ${bookAuthor}</p>
  <p class="text-about-book-modal">${descriptionMarkup}</p>
  <ul class="shop-modal-list"> <li class="shop-modal-item"><a href="${marketAmazon}" target="_blank"
    > <img class="amazon"
     width="62"
    height="19"
    srcset="
    ${(0, (/*@__PURE__*/$parcel$interopDefault($970c8eaba6989662$exports)))} 1x,
    ${(0, (/*@__PURE__*/$parcel$interopDefault($6ac5049c15344dc8$exports)))} 2x
  "
   src="${(0, (/*@__PURE__*/$parcel$interopDefault($970c8eaba6989662$exports)))}"
    alt="Amazon"
  /></a></li>
  <li class="shop-modal-item"><a href="${marketAppleBooks}" target="_blank"
    > <img class="marketApple"
    width="33"
    height="32"
    srcset="
    ${(0, (/*@__PURE__*/$parcel$interopDefault($8d03bf859c00cd96$exports)))} 1x,
    ${(0, (/*@__PURE__*/$parcel$interopDefault($cff94b9787371d15$exports)))} 2x
  "
   src="${(0, (/*@__PURE__*/$parcel$interopDefault($8d03bf859c00cd96$exports)))}"
    alt="AppleBooks"
  /></a></li>
  <li class="shop-modal-item"><a href="${marketBookshop}" target="_blank"
    > <img
    width="38"
    height="36"
    srcset="
    ${(0, (/*@__PURE__*/$parcel$interopDefault($9242bc8258ebce81$exports)))} 1x,
    ${(0, (/*@__PURE__*/$parcel$interopDefault($4c66a77d1ca3dce7$exports)))} 2x
  "
   src="${(0, (/*@__PURE__*/$parcel$interopDefault($9242bc8258ebce81$exports)))}"
    alt="Book-Shop"
  /></a></li>
</ul>
</div>
  `;
    $02917533890b81a6$var$allModal.innerHTML = html;
}
function $02917533890b81a6$var$onStorageAdd() {
    const realStorageArr = JSON.parse(localStorage.getItem($02917533890b81a6$var$STORAGE_KEY));
    if (!$02917533890b81a6$var$storageObj.description) $02917533890b81a6$var$storageObj.description = "Unfortunately, a brief description of this book is currently unavailable. But let that not hinder you from opening its pages and immersing yourself in the unforgettable world it creates.";
    const dataToSave = $02917533890b81a6$var$storageObj;
    if (!realStorageArr || realStorageArr.length === 0) {
        $02917533890b81a6$var$storageArr = [
            dataToSave
        ];
        localStorage.setItem($02917533890b81a6$var$STORAGE_KEY, JSON.stringify($02917533890b81a6$var$storageArr));
    } else {
        realStorageArr.push(dataToSave);
        localStorage.setItem($02917533890b81a6$var$STORAGE_KEY, JSON.stringify(realStorageArr));
    }
    $02917533890b81a6$var$storageDescription.textContent = "Сongratulations! You have added the book to the shopping list. To delete, press the button “Remove from the shopping list”.";
    const localArray = JSON.parse(localStorage.getItem($02917533890b81a6$var$STORAGE_KEY));
    if (localArray.length === 1) (0, $ipb79.reportsInfo)(`You added book to the shopping list. You have ${localArray.length} book in your shopping list`);
    else (0, $ipb79.reportsInfo)(`You added book to the shopping list. You have ${localArray.length} books in your shopping list`);
    $02917533890b81a6$var$storageCheck();
}
function $02917533890b81a6$var$onStorageDelete() {
    $02917533890b81a6$var$storageDescription.textContent = "";
    const idToDelete = $02917533890b81a6$var$storageObj.id;
    const storageArr = JSON.parse(localStorage.getItem($02917533890b81a6$var$STORAGE_KEY));
    const indexToDelete = storageArr.findIndex((obj)=>obj.id === idToDelete);
    storageArr.splice(indexToDelete, 1);
    if (storageArr.length === 1) (0, $ipb79.reportsInfo)(`You removed book from your shopping list. You have ${storageArr.length} book in your shopping list`);
    else if (storageArr.length === 0 || !storageArr.length) (0, $ipb79.reportsInfo)("Your shopping list is empty");
    else storageArr.length;
    localStorage.setItem($02917533890b81a6$var$STORAGE_KEY, JSON.stringify(storageArr));
    $02917533890b81a6$var$storageCheck();
}
// Функція, яка закриває модальне вікно
const $02917533890b81a6$var$backdrop = document.querySelector(".card-backdrop-modal");
const $02917533890b81a6$var$modal = document.querySelector(".modal");
const $02917533890b81a6$var$closeButton = document.getElementById("modal-close");
function $02917533890b81a6$var$closeModal() {
    var _document_body;
    $02917533890b81a6$var$backdrop === null || $02917533890b81a6$var$backdrop === void 0 ? void 0 : $02917533890b81a6$var$backdrop.classList.add("is-hidden");
    $02917533890b81a6$var$modal === null || $02917533890b81a6$var$modal === void 0 ? void 0 : $02917533890b81a6$var$modal.classList.add("is-hidden");
    (_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.classList.remove("modal-open");
    document.removeEventListener("keydown", $02917533890b81a6$var$closeModalOnEsc);
    document.body.style.overflow = "";
    (0, $7c9b6e419670c53b$export$ad5e81312907638b).show();
}
// Функція, яка закриває модальне вікно при кліку на backdrop
function $02917533890b81a6$var$closeModalOnBackdropClick(event) {
    if (event.target === $02917533890b81a6$var$backdrop) $02917533890b81a6$var$closeModal();
}
// Функція, яка закриває модальне вікно при кліку на хрестик
function $02917533890b81a6$var$closeModalOnButton() {
    $02917533890b81a6$var$closeModal();
}
// Функція, яка закриває модальне вікно при натисканні на ESC
function $02917533890b81a6$var$closeModalOnEsc(event) {
    if (event.code === "Escape") $02917533890b81a6$var$closeModal();
}
if ($02917533890b81a6$var$modal) {
    $02917533890b81a6$var$backdrop === null || $02917533890b81a6$var$backdrop === void 0 ? void 0 : $02917533890b81a6$var$backdrop.addEventListener("click", $02917533890b81a6$var$closeModalOnBackdropClick);
    $02917533890b81a6$var$closeButton === null || $02917533890b81a6$var$closeButton === void 0 ? void 0 : $02917533890b81a6$var$closeButton.addEventListener("click", $02917533890b81a6$var$closeModalOnButton);
    window.addEventListener("keydown", $02917533890b81a6$var$closeModalOnEsc);
}


parcelRequire("cZaO3");
const $91218dea788ee80e$var$wraperMobileMenuEl = document.querySelector(".js-wraper-mobile-menu");
const $91218dea788ee80e$var$menuMobileEl = document.querySelector(".js-modal-mobile-menu");
const $91218dea788ee80e$var$burgerBtnEl = document.querySelector(".js-burger");
const $91218dea788ee80e$var$closeModalBtnEl = document.querySelector(".js-close-menu");
const $91218dea788ee80e$var$headerEl = document.querySelector(".header-container");
const $91218dea788ee80e$var$body = document.body;
const $91218dea788ee80e$var$homeBtnEl = document.querySelector(".js-modal-home-btn");
const $91218dea788ee80e$var$listBtnEl = document.querySelector(".js-modal-list-btn");
const $91218dea788ee80e$var$iconListBtn = document.querySelector(".list-btn-svg-menu");
$91218dea788ee80e$var$burgerBtnEl === null || $91218dea788ee80e$var$burgerBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$burgerBtnEl.addEventListener("click", $91218dea788ee80e$var$showModal);
$91218dea788ee80e$var$closeModalBtnEl === null || $91218dea788ee80e$var$closeModalBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$closeModalBtnEl.addEventListener("click", $91218dea788ee80e$var$closeModal);
if (window.location.href === $91218dea788ee80e$var$listBtnEl.href) {
    $91218dea788ee80e$var$listBtnEl.classList.add("current");
    $91218dea788ee80e$var$homeBtnEl.classList.remove("current");
    $91218dea788ee80e$var$iconListBtn.classList.remove("fill");
    $91218dea788ee80e$var$homeBtnEl.classList.add("pudding");
} else if (window.location.href === $91218dea788ee80e$var$homeBtnEl.href) {
    $91218dea788ee80e$var$homeBtnEl.classList.remove("pudding");
    $91218dea788ee80e$var$listBtnEl.classList.add("padding");
    $91218dea788ee80e$var$iconListBtn.classList.add("fill");
}
function $91218dea788ee80e$var$showModal(elem) {
    $91218dea788ee80e$var$headerEl === null || $91218dea788ee80e$var$headerEl === void 0 ? void 0 : $91218dea788ee80e$var$headerEl.classList.add("index");
    $91218dea788ee80e$var$wraperMobileMenuEl === null || $91218dea788ee80e$var$wraperMobileMenuEl === void 0 ? void 0 : $91218dea788ee80e$var$wraperMobileMenuEl.classList.add("no-scroll");
    $91218dea788ee80e$var$body === null || $91218dea788ee80e$var$body === void 0 ? void 0 : $91218dea788ee80e$var$body.classList.add("no-scroll");
    $91218dea788ee80e$var$wraperMobileMenuEl === null || $91218dea788ee80e$var$wraperMobileMenuEl === void 0 ? void 0 : $91218dea788ee80e$var$wraperMobileMenuEl.classList.remove("is-hidden-mobile");
    $91218dea788ee80e$var$menuMobileEl.classList.add("active-mobile-menu");
    $91218dea788ee80e$var$burgerBtnEl === null || $91218dea788ee80e$var$burgerBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$burgerBtnEl.classList.add("is-hidden-btn");
    $91218dea788ee80e$var$closeModalBtnEl === null || $91218dea788ee80e$var$closeModalBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$closeModalBtnEl.classList.remove("is-hidden-btn");
}
function $91218dea788ee80e$var$closeModal() {
    $91218dea788ee80e$var$wraperMobileMenuEl === null || $91218dea788ee80e$var$wraperMobileMenuEl === void 0 ? void 0 : $91218dea788ee80e$var$wraperMobileMenuEl.classList.remove("no-scroll");
    //wraperMobileMenuEl?.classList.add('is-hidden-mobile')
    $91218dea788ee80e$var$burgerBtnEl === null || $91218dea788ee80e$var$burgerBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$burgerBtnEl.classList.remove("is-hidden-btn");
    $91218dea788ee80e$var$closeModalBtnEl === null || $91218dea788ee80e$var$closeModalBtnEl === void 0 ? void 0 : $91218dea788ee80e$var$closeModalBtnEl.classList.add("is-hidden-btn");
    $91218dea788ee80e$var$body === null || $91218dea788ee80e$var$body === void 0 ? void 0 : $91218dea788ee80e$var$body.classList.remove("no-scroll");
    $91218dea788ee80e$var$menuMobileEl.classList.remove("active-mobile-menu");
}
const $91218dea788ee80e$var$home = document.querySelector(".modal-home-btn");
const $91218dea788ee80e$var$list = document.querySelector(".modal-list-btn");
$91218dea788ee80e$var$list.addEventListener("click", ()=>{
    if (window.location.href === "shoplist" && $91218dea788ee80e$var$list.textContent === "Shopping list") $91218dea788ee80e$var$list.classList.add("current");
});


const $7aee77bfcfc3eba8$var$checkBoxEl = document.querySelector("#checkbox");
const $7aee77bfcfc3eba8$var$body = document.querySelector("body");
const $7aee77bfcfc3eba8$var$Theme = {
    LIGHT: "light-theme",
    DARK: "dark-theme"
};
const $7aee77bfcfc3eba8$var$STORAGE_KEY = "theme";
if ($7aee77bfcfc3eba8$var$checkBoxEl) $7aee77bfcfc3eba8$var$checkBoxEl.addEventListener("change", $7aee77bfcfc3eba8$export$2e2bcd8739ae039);
$7aee77bfcfc3eba8$var$savedThemeOnReloaded();
function $7aee77bfcfc3eba8$export$2e2bcd8739ae039(evt) {
    let value = "";
    if (evt.currentTarget.checked) {
        value = $7aee77bfcfc3eba8$var$Theme.DARK;
        $7aee77bfcfc3eba8$var$body.classList.add(value);
        $7aee77bfcfc3eba8$var$body.classList.remove($7aee77bfcfc3eba8$var$Theme.LIGHT);
    } else {
        value = $7aee77bfcfc3eba8$var$Theme.LIGHT;
        $7aee77bfcfc3eba8$var$body.classList.remove($7aee77bfcfc3eba8$var$Theme.DARK);
        $7aee77bfcfc3eba8$var$body.classList.add(value);
    }
    localStorage.setItem($7aee77bfcfc3eba8$var$STORAGE_KEY, value);
}
function $7aee77bfcfc3eba8$var$savedThemeOnReloaded() {
    const savedValue = localStorage.getItem($7aee77bfcfc3eba8$var$STORAGE_KEY);
    if (savedValue) $7aee77bfcfc3eba8$var$body === null || $7aee77bfcfc3eba8$var$body === void 0 ? void 0 : $7aee77bfcfc3eba8$var$body.classList.add(savedValue);
    else $7aee77bfcfc3eba8$var$body === null || $7aee77bfcfc3eba8$var$body === void 0 ? void 0 : $7aee77bfcfc3eba8$var$body.classList.add($7aee77bfcfc3eba8$var$Theme.LIGHT);
    if ($7aee77bfcfc3eba8$var$checkBoxEl) {
        if (savedValue === $7aee77bfcfc3eba8$var$Theme.DARK) $7aee77bfcfc3eba8$var$checkBoxEl.checked = true;
        else $7aee77bfcfc3eba8$var$checkBoxEl.checked = false;
    }
}



parcelRequire("d0qiv");
parcelRequire("ipb79");
parcelRequire("7t6q4");
parcelRequire("bWpVP");


//# sourceMappingURL=index.7886e6ac.js.map
